import { render, staticRenderFns } from "./administratorsList.vue?vue&type=template&id=3641703a&scoped=true&"
import script from "./administratorsList.vue?vue&type=script&lang=js&"
export * from "./administratorsList.vue?vue&type=script&lang=js&"
import style0 from "./administratorsList.vue?vue&type=style&index=0&id=3641703a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641703a",
  null
  
)

export default component.exports